import { useState, useEffect, useRef } from "react";
import SpinnerComponent from "../SpinnerComponent/SpinnerComponent";
import QuestionComponent from "../QuestionComponent/QuestionComponent";
import QualificationComponent from "../Qualification/Qualification";
import RankingComponent from "../RankingComponent/RankingComponent";
import styles from "./GameInProgress.module.css";

import { GameProvider } from "../GameContext";

import { ANIMATIONS, GameStates } from "../../utils/constants";
import { useInGameMessages } from "../../hooks/useInGameMessages";
import Modal from "../modal/modal";
import QuestionTextContainer from "../QuestionComponent/QuestionTextContainer/QuestionTextContainer";


const GameInProgress = ({ user, game, socket, room }) => {
  const [animation, setAnimation] = useState(1);
  const audioRef = useRef(null); // Referencia para el audio

  const previousStateRef = useRef(null);
  const lastChallengeIdRef = useRef(null);
  const { inGameMessage, changeInGameMessage } = useInGameMessages();

  useEffect(() => {

    if (!audioRef.current) {
      return;
    }

    audioRef.current.loop = true;
    audioRef.current.volume = 0.3;

    audioRef.current.addEventListener('loadedmetadata', () => {
      audioRef.current.muted = false;
    });

  }, [game.state]);

  useEffect(() => {
    handleNextMessage(game);
  }, [game]);

  const handleNextMessage = (game) => {
    // If the game state is spinner, we need to check if the challenge id is the same as the last one in order to show the next challenge message.
    if (game?.state === GameStates.SPINNER) {
      if (lastChallengeIdRef.current === game?.current_question?.cardId) {
        return;
      };
      previousStateRef.current = game?.state;
      lastChallengeIdRef.current = game?.current_question?.cardId;
      changeInGameMessage(game, game?.timeToStart * 1000);
      return;
    }

    if (previousStateRef.current === game?.state) {
      return;
    };

    previousStateRef.current = game?.state;

    changeInGameMessage(game, game?.timeToStart * 1000);
  }

  //recibimnos un clip de animacion que mostrar
  //lo mostramos por un tiempo y despues pasamos al idle de regreso
  function PlayAnimation(clip, customTime = null) {
    if (clip != null) {
      setAnimation(clip);
    } else {
      setAnimation(ANIMATIONS.talking);
    }

    let t = 2500;
    if (clip === ANIMATIONS.hello) { t = 4000; }
    if (clip === ANIMATIONS.celebrating) { t = 3000; }

    if (customTime) {
      t = customTime;
    }

    setTimeout(() => {
      setAnimation(ANIMATIONS.idle);
    }, t);
  }

  return (
    <GameProvider user={user} game={game} socket={socket} room={room}>
      <div id="clouds">
        <div className="cloud x1"></div>
        <div className="cloud x2"></div>
        <div className="cloud x3"></div>
        <div className="cloud x4"></div>
        <div className="cloud x5"></div>
      </div>
      <div className={styles.screen}>

        {game.state !== '' &&
          <div className={styles.curtain}>
            <div className={styles.zigZagLineV}> </div>
          </div>
        }


        <div className={styles.gameInProgress}>
          <Modal show={(game?.state === GameStates.WELCOME || game?.state === GameStates.SPINNER) && !!inGameMessage}>
            <div className="absolute w-full h-full z-10 top-0 flex flex-col items-center justify-center">
              <QuestionTextContainer text={inGameMessage} animated />
            </div>
          </Modal>
          {game.state === GameStates.JOKER && <SpinnerComponent playAnimation={PlayAnimation} />}
          {game.state === "in_round" && <QuestionComponent playAnimation={PlayAnimation} />}
          {game.state === "qualification" && <QualificationComponent playAnimation={PlayAnimation} />}
          {(game.state === "final_ranking" || game.state === "ranking" || game.state === "winner") && <RankingComponent playAnimation={PlayAnimation} />}
        </div>
      </div>
    </GameProvider>
  );
}

export default GameInProgress;